import useSchema from "hooks/useSchema";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const useDynamicForm = () => {
    const { selectedCompany } = useSelector((state) => state.servicePayments);
    const [forms, setForms] = useState([]);
    const [dynamicSchema, setDynamicSchema] = useState({});
    const { stringRequired } = useSchema();

    const handleDynamicValues = useCallback((fields) => {
        const dynamicValues = {};
        const requiredFields = {};

        // eslint-disable-next-line no-restricted-syntax
        for (const input of fields) {
            // eslint-disable-next-line no-param-reassign
            dynamicValues[input.field] = "";
            requiredFields[input.field] = stringRequired;
        }
        setDynamicSchema(requiredFields);
        setForms(fields.sort((a, b) => a.position - b.position));

        return dynamicValues;
    }, []);

    useEffect(() => {
        setForms([]);
        setDynamicSchema({});
    }, [selectedCompany.companyCode]);

    return { forms, handleDynamicValues, dynamicSchema };
};

export default useDynamicForm;
